import React, { useContext } from "react";
import style from "./index.module.scss";
import ListItem from "components/CourseComponents/Vote/ListItem";
import SettingModal from "components/CourseComponents/Vote/SettingModal";
import CustomEmpty from "components/CourseComponents/CustomEmpty";
import useModalHandler from "utils/useModalHandler";
import { useHistory } from "react-router-dom";
import { CourseContext } from "../Store";
import useRequest from "utils/useRequest";
import { getVoteList } from "service/vote";
import { Spin } from "antd";
import qs from "qs";
import CourseButton from "components/CourseComponents/CourseButton";

export default function Vote() {
    const history = useHistory();
    const modal = useModalHandler();
    const { basename, course } = useContext(CourseContext);
    const [data, { loading }, refreshData] = useRequest(() =>
        getVoteList(course.weekTimeId)
    );

    function onOk() {
        refreshData();
        modal.close();
    }

    function gotoDetail(id: number, params?: any) {
        const query = params ? "?" + qs.stringify(params) : "";
        history.push(`${basename}/vote/${id}${query}`);
    }

    return (
        <div className={style.root}>
            <div className={style.header}>
                <div className={style.count}>
                    投票活动（{data?.length || 0}）
                </div>

                <CourseButton type="add" onClick={modal.open}>
                    添加
                </CourseButton>
            </div>

            <Spin spinning={loading}>
                {data?.map(item => (
                    <ListItem
                        key={item.id}
                        weekTimeId={course.weekTimeId}
                        data={item}
                        onClick={params => gotoDetail(item.id, params)}
                        onChange={refreshData}
                    />
                ))}

                {!data?.length && (
                    <CustomEmpty style={{ padding: "100px 0" }} />
                )}
            </Spin>

            <SettingModal
                weekTimeId={course.weekTimeId}
                visible={modal.visible}
                onCancel={modal.close}
                onOk={onOk}
                onShowVote={gotoDetail}
            />
        </div>
    );
}
